// i18n area 'system' — locale no-NO (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.no-NO.meta.json.
import type { enUS } from './system'

export const noNO: typeof enUS = {
  diagnostics: {
    title: 'Diagnostikk',
    subtitle: 'Hva som er galt, verst først — samme linse som tvirt diagnose',
    reload: 'Last på nytt',
    loadError: 'Diagnosen kunne ikke leses',
    exportBundle: 'Eksporter pakke',
    exportError: 'Pakken kunne ikke opprettes',
    noProblem: 'Ingen problemer i de inspiserte områdene',
    nothingInspected: 'INGENTING ble inspisert — dette er ikke en frisk­attest',
    inspected: 'Inspisert',
    notInspected: 'IKKE inspisert',
    localHint: 'Nodens lokale områder (systemd-enheter, journal) leses bare fra CLI: tvirt diagnose --area local — veien når API-et ikke svarer.',
    thresholds: 'mislykkede oppgaver innen {hours} t, heartbeat forsinket over {seconds} s',
    severity: {
      critical: 'Kritisk',
      warning: 'Advarsel',
      unknown: 'Ukjent'
    }
  },
  explorer: {
    title: 'Utforsk ressurser',
    root: 'Rot',
    empty: 'Ingen ressurser i denne scopen',
    previewHint: 'Velg et objekt for å se forhåndsvisningen',
    open: 'Åpne',
    openScoped: 'Åpne listen i denne scopen',
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM-template',
      ct: 'CT',
      ctTemplate: 'CT-template',
      app: 'App',
      overlayNetwork: 'Overlay-nettverk',
      networkService: 'Nettverkstjeneste',
      fabric: 'Fabric',
      subnet: 'Subnett',
      storage: 'Storage-pool',
      disk: 'Disk',
      catalogFile: 'Katalogfil',
      ociRegistry: 'OCI-registry',
      ociImage: 'OCI-bilde',
      cephCluster: 'Ceph-kluster',
      backupDestination: 'Backup-mål',
      user: 'Bruker',
      group: 'Gruppe',
      role: 'Rolle',
      credential: 'Legitimasjon',
      tag: 'Tagg',
      proximityRule: 'Nærhetsregel'
    }
  },
  tags: {
    title: 'Tagger',
    empty: 'Ingen tagger',
    add: 'Legg til tagg',
    remove: 'Fjern',
    name: 'Tagg',
    value: 'Verdi',
    save: 'Lagre',
    saveError: 'Kunne ikke lagre taggene',
    loadError: 'Kunne ikke laste tagg-vokabularet',
    noVocabulary: 'Ingen tagg tilgjengelig for denne ressurstypen',
    overwrite: 'Erstatt den nåværende verdien',
    createTitle: 'Opprett tagg',
    editTitle: 'Rediger tagg',
    nameHint: 'Bokstaver, sifre, punktum, bindestreker og understrek — verken ":" eller "/"; prefikset tvirt- er reservert for plattformen',
    cardinality: 'Kardinalitet',
    cardinalitySingle: 'Én enkelt verdi',
    cardinalityMultiple: 'Flere verdier',
    cardinalityHint: 'Med én enkelt verdi ber en ny tildeling av taggen om å erstatte den',
    autoCreate: 'Auto-opprettelse av verdier',
    autoCreateOn: 'Ved tildeling',
    autoCreateOff: 'Bare deklarerte',
    autoCreateHint: 'På: å tildele en ny verdi oppretter den. Av: bare deklarerte verdier kan tildeles',
    values: 'Verdier',
    noValues: 'Ingen deklarerte verdier',
    addValue: 'Legg til verdi',
    duplicateValue: 'Duplisert verdi',
    kinds: 'Ressurstyper',
    kindsAll: 'Alle',
    kindsPlaceholder: 'Alle',
    kindsHint: 'La stå tomt for å tillate hver taggbar ressurstype',
    systemChip: 'System',
    deleteCascade: 'Fjern også tildelingene',
    deleteCascadeHint: 'En tagg som fortsatt er tildelt en ressurs, avvises: med dette valget forsvinner verdiene og alle tildelingene sammen med taggen.'
  },
  scopes: {
    title: 'Scoper',
    createTitle: 'Opprett scope',
    editTitle: 'Gi scopen nytt navn',
    path: 'Sti',
    segment: 'Segment',
    segmentHint: 'Små bokstaver, sifre og bindestreker (DNS-1123)',
    parent: 'Forelder',
    rootChip: 'Rot',
    preview: 'Ny scope',
    pickLabel: 'Scope',
    pickHint: 'Hvor objektet lever i kluster-treet — roten eller en vDC inni den.',
    ociCache: 'OCI-cache (override)',
    appEphemeral: 'Efemere App-pooler (override)',
    inherit: 'Arv',
    inheritsFrom: 'Arver fra',
    inheritsCluster: 'Arver klusterets default',
    inheritsNone: 'Arver — ingen effektiv pool',
    failoverProtection: 'Beskyttelse i degradert klynge',
    networkWeight: 'Nettverksvekt',
    networkCeil: 'Nettverkstak (Mbps)',
    protectionProtected: 'Beskyttet',
    protectionExpendable: 'Kan ofres ved degradering',
    protectionDefault: 'Klyngestandard'
  },
  sysinfo: {
    summary: 'Plattformversjoner i klusteret, komponentene til hver node, administrasjonshåndbok og lisens.',
    platformTitle: 'TVirt-plattformen',
    platformSubtitle: 'Versjoner observert på klusterets noder',
    versionOnNodes: '{version} på {n} noder',
    versionOnOneNode: '{version} på 1 node',
    mixedVersions: 'Mer enn én plattformversjon i klusteret — forventet bare under en pågående oppgradering (maks to).',
    tooManyVersions: 'Mer enn to plattformversjoner i klusteret — det er aldri forventet, ikke engang under en oppgradering: sjekk nodene nedenfor.',
    unreportedNodes: 'Ingen versjonsrapport ennå fra: {nodes}',
    noVersionsYet: 'Ingen node har rapportert versjonene sine ennå.',
    nodesUnavailable: 'Nodelisten er ikke synlig med tillatelsene dine — kan ikke vise plattformversjonene.',
    colNode: 'Node',
    manualTitle: 'Administrasjonshåndbok',
    manualSubtitle: 'Lokal kopi, servert fra dette klusteret',
    manualBody: 'Den komplette TVirt-manualen i PDF, servert direkte fra plattformen — tilgjengelig også i air-gappede miljøer.',
    manualLink: 'Administrasjonshåndbok (PDF)',
    apiExplorerTitle: 'API-utforsker',
    apiExplorerSubtitle: 'OpenAPI-kontrakten, til gjennomsyn',
    apiExplorerBody: 'Plattformens komplette OpenAPI-kontrakt — hver rute, hvert skjema og hver svarkode — kan utforskes fra nettleseren, servert gjennom denne noden.',
    apiExplorerLink: 'Utforsk API',
    kubeTitle: 'Kubernetes-kompatibilitet',
    kubeSubtitle: 'kubectl og verktøyene rundt det, foran det native API-et',
    kubeBody: 'TVirt KubeCompat projiserer Pods, Deployments, Services, namespaces, noder og hendelser i Kubernetes-dialekten — skrivebeskyttet, pluss sletting av Deployments. Hvert kall går gjennom det native API-et med dine rettigheter: bruk et app-token som bearer i kubeconfig.',
    kubeEndpoint: 'Endepunkt for kubectl',
    kubeStatusActive: 'Aktiv — Kubernetes {version}',
    kubeStatusMissing: 'Ikke installert på denne noden (pakken trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Installert, men svarer ikke — sjekk enheten trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Sjekker…'
  },
  licensing: {
    title: 'Klusterets lisens',
    subtitle: 'Abonnementslisens — maks én per kluster',
    absentTitle: 'Ingen registrert lisens',
    absentBody:
      'Uten en gyldig lisens nekter klusteret å starte nye virtuelle maskiner (påslåtte VM-er forblir på). Registrer product key-en du fikk med abonnementet.',
    registerButton: 'Registrer lisens',
    removeButton: 'Fjern lisens',
    state: {
      ok: 'Gyldig',
      limitExceeded: 'Grense overskredet',
      expired: 'Utløpt'
    },
    productKeyLabel: 'Product key',
    basisLabel: 'Grunnlag for grensen',
    basis: {
      concurrentVms: 'Samtidig påslåtte VM-er',
      physicalCores: 'Fysiske kjerner (kluster totalt)'
    },
    limitLabel: 'Grense',
    usageLabel: 'Nåværende bruk',
    usageOf: '{used} av {limit}',
    usagePartial: 'delvis sum — {n} node(r) uten observert CPU-topologi',
    usageUnknown: 'ikke observerbar akkurat nå',
    expiresLabel: 'Utløp',
    neverExpires: 'aldri',
    registeredLabel: 'Registrert',
    gateNote:
      'Med lisens som mangler, er utløpt eller over grensen nekter klusteret å starte NYE virtuelle maskiner. Påslåtte VM-er forblir på, og HA-omstarter berøres ikke.',
    devStage:
      'Utviklingsfase: product key-en aksepteres som den er, sammen med grensene som deklareres her; validering med signert nøkkel kommer i en fremtidig release.',
    dialogTitle: 'Registrer lisens',
    dialogExpiresHelp: 'Tomt = lisensen utløper aldri',
    dialogSubmit: 'Registrer',
    dialogError: 'Kunne ikke registrere lisensen.',
    removeTitle: 'Fjern lisens',
    removeBody:
      'Klusteret blir stående UTEN LISENS: nye virtuelle maskiner nekter å starte til du registrerer en. Påslåtte VM-er forblir på.',
    removeConfirm: 'Fjern',
    removeError: 'Kunne ikke fjerne lisensen.'
  },
  rbac: {
    tabRoles: 'Roller',
    tabGrants: 'Delegeringer',
    rolesTitle: 'Roller',
    createRoleTitle: 'Opprett rolle',
    editRoleTitle: 'Rediger rolle',
    nameHint: 'Små bokstaver, sifre og bindestreker; prefikset tvirt- er reservert',
    systemChip: 'System',
    permissions: 'Tillatelser',
    permissionsPlaceholder: 'Legg til tillatelse…',
    includedRoles: 'Inkluderte roller',
    includedRolesPlaceholder: 'Legg til rolle…',
    grantsTitle: 'Delegeringer',
    createGrantTitle: 'Opprett delegering',
    principal: 'Principal',
    principalKind: 'Principal-type',
    principalUser: 'Bruker',
    principalGroup: 'Gruppe',
    role: 'Rolle',
    grantRight: 'Delegering',
    grantRightChip: 'Kan delegere',
    grantRightLabel: 'Med delegeringsrett (mottakeren kan i sin tur delegere denne rollen)',
    effective: 'Effektiv',
    notEffective: 'Ikke effektiv',
    createdAt: 'Opprettet',
    scopeHint: '/path eksakt, /path/* rekursivt — delegeringene forankres i en montert rot (/* er ikke delegerbar)'
  },
  groups: {
    title: 'Grupper',
    createTitle: 'Opprett gruppe',
    nameHint: 'Små bokstaver, sifre og bindestreker; unikt i scopen',
    members: 'Medlemmer',
    membersTitle: 'Medlemmer',
    membersPlaceholder: 'Legg til bruker…',
    noMembers: 'Ingen medlemmer',
    realmMappings: 'Realm-mappinger',
    realmMappingsTitle: 'Realm-mappinger',
    realmMappingsHint:
      'Hva denne gruppen tilsvarer i hvert eksterne realm. Medlemskapet leses fra directoryen ved innlogging: en directory-gruppe ingen mapper her ignoreres, og nesting løses ikke opp — den må flates ut på directory-siden.',
    realm: 'Realm',
    externalGroup: 'Ekstern gruppe',
    addRealmMapping: 'Legg til mapping',
    removeRealmMapping: 'Fjern mapping',
    noRealmMappings: 'Ingen realm-mapping',
    sectionGeneral: 'Generelt',
    mappingsNoRealms: 'Ingen eksterne realm konfigurert — mapping-flaten låses opp så snart et realm finnes.',
    mappingsNoRealmsLink: 'Åpne fanen Realm og SSO',

    // MFA-påbudet pålagt av gruppen (runde #178, halvdel B): en ren OR — en
    // gruppe kan bare LEGGE TIL påbudet, aldri oppheve det.
    mfaRequired: 'MFA-påbud',
    mfaRequiredChip: 'Pålegger MFA',
    mfaNotRequiredChip: 'Ikke noe påbud',
    mfaRequiredHint:
      'Ren OR: en gruppe kan LEGGE TIL påbudet om andre faktor for medlemmene sine — også for eksterne identiteter, via realm-mappingene — aldri oppheve det. Det gjelder fra neste innlogging: åpne sesjoner lukkes ikke.'
  },
  users: {
    title: 'Brukere',
    createTitle: 'Opprett bruker',
    editTitle: 'Rediger bruker',
    username: 'Brukernavn',
    usernameHint: 'Små bokstaver, sifre, punktum og bindestreker',
    displayName: 'Visningsnavn',
    enabled: 'Aktivert',
    state: 'Status',
    enabledChip: 'Aktivert',
    disabledChip: 'Deaktivert',
    lockedChip: 'Låst',
    password: 'Passord',
    passwordSetChip: 'Satt',
    mustChangeChip: 'Må byttes',
    initialPassword: 'Startpassord',
    initialPasswordHint: 'Brukeren må bytte det ved første innlogging',
    lastLogin: 'Siste innlogging',
    neverLoggedIn: 'Aldri logget inn',
    setPasswordTitle: 'Sett passord',
    setPasswordHint: 'Administrativ erstatning — krever passordet ditt (sudo-modus) og tvinger brukeren til å bytte det ved neste innlogging.',
    operatorPassword: 'Passordet ditt',
    unlock: 'Lås opp kontoen',
    revokeTitle: 'Tilbakekall sesjoner',
    revokeBody: 'Alle aktive sesjoner for denne brukeren termineres umiddelbart.',
    revokeIncludeTokens: 'Tilbakekall også app-tokenene',
    revokeConfirm: 'Tilbakekall',
    tabAccount: 'Konto',
    tabSecurity: 'Sikkerhet',
    usernameImmutableHint: 'Brukernavnet er kontoens identitet — fastsatt ved opprettelsen',
    groups: 'Grupper',
    noGroups: 'Ingen grupper',
    mustChangePassword: 'Obligatorisk passordbytte',
    failedAttempts: 'Mislykkede innloggingsforsøk',
    lockedUntil: 'Låst til',
    tabUsers: 'Brukere',
    tabGroups: 'Grupper',
    tabRealms: 'Realm og SSO',
    tabMfa: 'MFA',
    mfa: {
      title: 'Andre faktor (MFA)',
      methodsTitle: 'Tilgjengelige metoder',
      methodsSubtitle: 'Det denne installasjonen kan verifisere som andre faktor',
      methodsError: 'Kunne ikke laste metoderegisteret',
      builtinChip: 'Innebygd',
      enrollableChip: 'Enrollment i TVirt',
      delegatedChip: 'Håndteres eksternt',
      state: 'Status',
      stateActive: 'Aktiv',
      statePending: 'Venter på enrollment',
      stateNone: 'Ikke enrollert',
      required: 'MFA-påbud',
      requiredChip: 'Obligatorisk',
      notRequiredChip: 'Ikke obligatorisk',
      enrolledAt: 'Enrollment den',
      enrolledMethods: 'Enrollerte metoder',
      noMethods: 'Ingen enrollment',
      codesRemaining: 'Gjenværende gjenopprettingskoder',
      resetTitle: 'Nullstill den andre faktoren',
      resetHint:
        'Enrollmenten og alle gjenopprettingskodene nullstilles: ved neste innlogging gjør brukeren enrollmenten på nytt fra bunnen av. MFA-påbudet forblir som det er — en administrator setter aldri en hemmelighet, bare nullstiller den.',
      resetConfirm: 'Nullstill',
      resetError: 'Kunne ikke nullstille den andre faktoren',
      empty: 'Ingen forvaltede brukere ennå — kontoene dukker opp her så snart de finnes, hver med statusen til sin andre faktor.',

      // Halvdel B (runde #178): opphavet til det gjeldende påbudet, eksterne
      // enrollments med foreldreløs-status, grupper som pålegger påbudet.
      viaSelf: 'Personlig',
      viaSelfHint: 'Kontoens personlige bidrag (dens flagg) — den eneste delen blyanten redigerer.',
      viaGroupHint: 'Påbud arvet fra denne gruppen: å fjerne det personlige flagget frigjør ikke brukeren — man griper inn på gruppen, i fanen Grupper.',
      subject: 'Identitet',
      lastSeenAt: 'Sist bekreftet',
      enrollmentPending: 'Venter',
      orphanChip: 'Foreldreløs',
      orphanDirectoryMiss: 'Identiteten finnes ikke lenger i directoryen',
      orphanRealmRemoved: 'Realmet ble fjernet fra TVirt',
      orphanedAt: 'Foreldreløs siden',
      directoryUuid: 'UUID i directoryen',
      externalTitle: 'Eksterne enrollments',
      externalEmpty: 'Ingen ekstern enrollment ennå — den oppstår ved første innlogging for en directory-identitet med MFA-påbud.',
      orphanHelp:
        'En foreldreløs enrollment sletter aldri seg selv: den er sikkerhetsmateriale — den blir igjen for auditen, og dukker identiteten opp i directoryen igjen, finner den faktoren sin igjen. Den eneste utveien er den administrative nullstillingen.',
      visibilityHint: 'Eksterne enrollments bor i roten av klusteret: bare den som har user.read over hele treet, ser dem.',
      orphanResetHint:
        'Den foreldreløse raden fjernes for godt: ingen gjør krav på den lenger. Dukker identiteten opp i directoryen igjen, gjør den enrollmenten på nytt fra bunnen av.',
      enforcingTitle: 'Grupper som pålegger MFA',
      enforcingSubtitle:
        'Ankeret for påbudet for eksterne identiteter er gruppen: realm-mappingene dens sier hvilken directory-populasjon det når. Den eksterne enrollmenten oppstår ved første innlogging for den pålagte brukeren.',
      enforcingEmpty: 'Ingen gruppe pålegger MFA — påbudet slås på på gruppen, fra fanen Grupper.',
      enforcingError: 'Kunne ikke laste gruppene som pålegger MFA'
    }
  },
  realms: {
    title: 'Autentiserings-realm',
    createTitle: 'Opprett realm',
    editTitle: 'Rediger realm',
    name: 'Realm',
    nameHint: 'Domenet brukerne skriver etter @ (example.com) — uforanderlig etter opprettelsen',
    nameImmutableHint: 'Realm-navnet er stemplet i hver sesjon og i hver audit-linje som noen gang har nevnt det — å gi det nytt navn ville skrevet om historien',
    kind: 'Type',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC og SAML kommer med de neste rundene — i dag er et realm en LDAPv3-directory',
    kindCategory: 'Realm-type',
    kindSelectHint: 'Velg typen directory dette realmet skal autentisere mot.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Brukernavn og passord verifisert med en bind mot en LDAPv3-directory — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on fra browseren delegert til en OpenID Connect-identity provider — kommer med de neste rundene.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Single sign-on for bedrifter med SAML 2.0-assertions — kommer med de neste rundene.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Aktivert',
    urls: 'Directory-servere',
    urlsHint: 'Én ldap://- eller ldaps://-URL per linje (1–8), prøvd i rekkefølge — failover, aldri balansering',
    startTls: 'StartTLS',
    verifyCertificate: 'Verifiser sertifikatet',
    cleartextWarning: 'Uten ldaps:// eller StartTLS krysser bind-passordet nettverket i klartekst — akseptabelt i laben, aldri i produksjon.',
    noVerifyWarning: 'En uverifisert TLS-sesjon autentiserer ingen: slå av verifiseringen bare mot en directory du ikke kan fikse.',
    caCertificate: 'CA-sertifikat (PEM)',
    caCertificateHint: 'Valgfri CA-bundle pinnet for TLS/StartTLS-handshaken til dette realmet; tomt fjerner den',
    caCertificatePinned: 'Pinnet',
    connectTimeout: 'Timeout (sekunder)',
    connectTimeoutHint: 'Per-URL-frist for tilkobling og forespørsel (1–60); når den utløper prøves neste URL',
    bindDn: 'Bind-DN',
    bindDnHint: 'Service-accounten som utfører brukersøket; tomt = anonym search bind (avvist av AD)',
    anonymousBind: 'Anonym search bind',
    bindCredential: 'Bind-passord (keystore)',
    bindCredentialHint: 'En usernamePassword-oppføring i keystoren med bind-passordet — hemmeligheten lever aldri på realmet',
    bindCredentialNone: 'Ingen (anonym bind)',
    bindCredentialEmpty: 'Ingen usernamePassword-oppføring i keystoren — opprett en i System > Legitimasjoner for bind-passordet.',
    baseDn: 'Base-DN',
    baseDnHint: 'Undertreet brukersøket starter fra (DC=example,DC=com)',
    userFilter: 'Brukerfilter',
    userFilterHint: '%u erstattes av den lokale delen av innloggingen, med RFC 4515-escaping; ikke-AD-directoryer vil typisk ha (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'memberOf-attributt',
    memberOfAttributeHint: 'Leses én eneste gang, ved innlogging — umappede grupper ignoreres, nesting løses ikke opp',
    uuidAttribute: 'UUID-attributt',
    uuidAttributeHint: 'Den uforanderlige UUID-en i realmet (objectGUID på AD, entryUUID på OpenLDAP) — stemplet i auditen ved siden av bruker@realm',
    displayNameAttribute: 'Visningsnavn-attributt',
    displayNameAttributeHint: 'Brukes for å hilse på brukeren; mangler det brukes innloggingsnavnet',
    sudoHint: 'Skrivinger på realm er sudo-beskyttet: et realm er en inngangsdør til plattformen',
    deleteBody: 'Gruppemappingene til realmet går med det; sesjonene det har autentisert lever videre til de utløper — et slettet realm slipper rett og slett ikke inn noen flere.',
    tabConnection: 'Tilkobling',
    tabDirectory: 'Directory',
    testTitle: 'Test tilkobling',
    testHint: 'En konfigurasjonssonde, aldri en autentisering: den kobler til, gjør bind med service-accounten og — med et brukernavn — kjører brukerfilteret.',
    testUsername: 'Brukernavn (valgfritt)',
    testUsernameHint: 'En lokal del å kjøre brukerfilteret på — 1 treff er det sunne svaret',
    testRun: 'Kjør test',
    testError: 'Kunne ikke kjøre sonden',
    testReachable: 'Directory tilgjengelig, service-bind akseptert',
    testUnreachable: 'Directory IKKE tilgjengelig',
    matchedOne: 'Brukerfilteret fant nøyaktig 1 oppføring — det sunne svaret.',
    matchedNone: 'Brukerfilteret fant ingen oppføring: filteret eller base-DN-et er feil.',
    matchedMany: 'Brukerfilteret fant {count} oppføringer: det er ikke selektivt, og innlogginger ville vært tvetydige (avvist).',
    mappingsPointer: 'Hva en ekstern gruppe tilsvarer er en egenskap ved TVirt-gruppen (dens realm-mappinger): sannhetspunktet lever i fanen Grupper.',
    mappingsPointerLink: 'Åpne fanen Grupper',
    rootHomeHint: 'Identitetene i et eksternt realm lever i klusterets rot, aldri i en vDC: tillatelser tildeles der de trengs, med delegeringene — på gruppen eller direkte på brukeren, akkurat som for de native.'
  },
  credentials: {
    title: 'Legitimasjoner',
    createTitle: 'Opprett legitimasjon',
    editTitle: 'Rediger legitimasjon',
    kind: 'Type',
    kindUsernamePassword: 'Brukernavn og passord',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph-identitet)',
    kindHintUsernamePassword: 'Uforanderlig. For CIFS/SMB-storager — mount-kontoen hvis hemmelighet workeren bruker i mount-øyeblikket.',
    kindHintIscsiChap: 'Uforanderlig. For iSCSI CHAP-autentisering — username = CHAP-navn, secret = CHAP-hemmelighet.',
    kindHintNvmeDhchap: 'Uforanderlig. For DH-HMAC-CHAP i NVMe over Fabrics — secret = DHHC-1:xx:…-bloben; brukernavnet er bare en etikett.',
    kindHintCephx: 'Uforanderlig. For Ceph-klienter — username = klientnavn (client.…), secret = base64-nøkkelen.',
    kindImmutableHint: 'Typen er uforanderlig etter opprettelsen — å bytte den betyr en ny legitimasjon.',
    username: 'Brukernavn',
    usernameChap: 'CHAP-navn',
    usernameNvme: 'Etikett',
    usernameCephx: 'Klientnavn',
    usernameHint: 'Valgfri konto hemmeligheten tilhører',
    usernameHintChap: 'CHAP-navnet initiatoren autentiserer seg med',
    usernameHintNvme: 'Ikke brukt av transporten — en fri etikett for notatene dine',
    usernameHintCephx: 'Navnet på cephx-klienten — prefikset client. tolereres',
    secret: 'Hemmelighet',
    secretHint: 'Write-only: brukes av konsumentene, vises aldri igjen.',
    secretHintNvmeDhchap: 'Write-only: DH-HMAC-CHAP-host-hemmeligheten i den kanoniske formen DHHC-1:xx:… — brukes av konsumentene, vises aldri igjen.',
    secretHintCephx: 'Write-only: cephx-nøkkelen i base64 — brukes av konsumentene, vises aldri igjen.',
    secretEditHint: 'La stå tomt for ikke å endre hemmeligheten — å fylle det ut roterer den.',
    createdAt: 'Opprettet',
    inUseError: "'{name}' refereres av konfigurasjonen til en storage — koble den fra der først.",
    nameHint: 'Små bokstaver, sifre og bindestreker (DNS-1123); unik per scope',
    rotateTitle: 'Roter hemmelighet',
    rotateHint: 'Write-only: den nye hemmeligheten erstatter den lagrede — konsumentene bruker den ved neste mount.',
    tabSecrets: 'Hemmeligheter',
    tabCertificates: 'Sertifikater',
    tabAuthorities: 'Sertifikatautoriteter',
    certificatesTitle: 'Sertifikater',
    authoritiesTitle: 'Sertifikatautoriteter',
    caCreateTitle: 'Ny CA',
    certCreateTitle: 'Nytt sertifikat',
    caMode: 'Opphav',
    caModeGenerate: 'Generer med TVirt',
    caModeImport: 'Importer (nøkkel + sertifikat)',
    certMode: 'Opphav',
    certModeIssue: 'Utsted fra en CA i keystoren',
    certModeImport: 'Importer (nøkkel + sertifikat)',
    issuingCa: 'Utstedende CA',
    issuingCaHint: 'Sertifikatet fødes i CA-ens scope, med forelderen registrert',
    noCasHint: 'Ingen CA i keystoren — generer eller importer en i CA-fanen først',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'CA-ens subject: bokstaver, sifre, mellomrom, punktum, understrek, bindestrek',
    commonNameCertHint: 'OpenVPN identifiserer klientene på CN — hold det unikt per CA',
    days: 'Gyldighet (dager)',
    daysCaHint: '1–7300 dager; 3650 (10 år) er default',
    daysCertHint: '1–3650 dager; 365 er default',
    keyType: 'Nøkkeltype',
    keyTypeHint: 'EC P-256 er default; RSA for legacy-konsumenter',
    usage: 'Bruk',
    usageClient: 'Klient (clientAuth)',
    usageServer: 'Server (serverAuth)',
    usageHint: 'Den extended key usage sertifikatet utstedes for',
    san: 'Alternative navn (SAN)',
    sanHint: 'Kommaseparert; IP-literaler blir IP:-oppføringer, resten DNS:',
    keyPem: 'Privat nøkkel (PEM)',
    keyPemHint: 'Write-only: oppbevart i keystoren, vises aldri igjen',
    certPem: 'Sertifikat (PEM)',
    certPemHint: 'Det offentlige sertifikatet som hører sammen med nøkkelen',
    certPemCaHint: 'CA-sertifikatet som hører sammen med nøkkelen (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Utsteder',
    parentCa: 'Utstedende CA',
    parentCaImported: 'Importert — utstedt utenfor TVirt',
    serial: 'Serienummer',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Gyldig fra',
    validUntil: 'Gyldig til',
    expiry: 'Utløp',
    expired: 'Utløpt',
    expiresInDays: 'Utløper om {days} d',
    revoked: 'Tilbakekalt',
    revokedAtLabel: 'Tilbakekalt den',
    revokeTitle: 'Tilbakekall sertifikat',
    revokeAction: 'Tilbakekall',
    revokeWarning: 'Tilbakekallingen er endelig: serienummeret går inn i CRL-en til den utstedende CA-en, og hver konsument som avviser tilbakekalte sertifikater (OpenVPN først av alle) vil avvise dette. Det finnes ingen un-revoke.',
    exportPem: 'Eksporter PEM',
    exportChain: 'Eksporter kjede-bundle',
    exportCrl: 'Eksporter CRL',
    materialImmutableHint: 'X.509-materialet er uforanderlig — utsted eller importer på nytt',
    caInUseError: "'{name}' har fortsatt levende utstedte sertifikater (eller en storage refererer den) — tilbakekall eller slett dem først."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Placement, tilgjengelighet og affinitet — hvor klusterets VM-er kjører og om de skal være på',
    loadError: 'Proximity-panelet krever kluster-storen — flåtestatusen er ikke tilgjengelig akkurat nå',
    config: {
      title: 'Konfigurasjon',
      subtitle: 'Placement-policy på klusternivå',
      save: 'Lagre',
      saveError: 'Konfigurasjonen ble avvist',
      strategy: 'Utvalgsstrategi',
      strategy_leastUsedResources: 'Minst brukte ressurser',
      strategy_leastVms: 'Færrest VM-er',
      strategy_random: 'Tilfeldig',
      strategyLeastUsedResourcesHint: 'Blant de gyldige kandidatene, noden med mest gjenværende brukbar RAM (observert totalt − host-reservasjon − påslåtte VM-er), vCPU-forpliktelse som tie-break. Deterministisk ved like data.',
      strategyLeastVmsHint: 'Blant de gyldige kandidatene, noden med færrest påslåtte VM-er; uavgjort løses på navn. Deterministisk ved like data.',
      strategyRandomHint: 'Uniformt tilfeldig blant de gyldige kandidatene.',
      liveness: 'Terskel for node-liveness (sekunder)',
      livenessHint: 'Et medlem som er stille utover terskelen er utilgjengelig: ekskludert fra placement og — hvis ikke i vedlikehold — regnet som dødt av HA-decideren, som fencer det og starter HA-VM-ene dets på nytt andre steder.',
      decider: 'HA-decider',
      deciderNone: 'ikke valgt ennå'
    },
    nodesTitle: 'Noder',
    nodesSubtitle: 'Liveness og empirisk kapasitet — brukbar RAM = totalt − base − forpliktet',
    nodeCol: 'Node',
    stateCol: 'Status',
    ramCol: 'RAM (totalt − base − forpliktet)',
    usableCol: 'Brukbar',
    vmsCol: 'Last',
    neverSeen: 'aldri sett',
    freshChip: 'tilgjengelig',
    staleChip: 'utilgjengelig',
    attestedChip: 'attestert avslått',
    ramFormula: 'totalt − base − forpliktet',
    haTitle: 'Høy tilgjengelighet',
    haSubtitle: 'VM-er med HA-flagg er "alltid på": TVirt starter dem på nytt etter hvert stopp som ikke var bedt om — samme node med backoff, en annen node når deres dør (bare delt storage).',
    haNone: 'Ingen VM har HA-flagget ennå — aktiver det her eller i VM-detaljen.',
    haVmCol: 'Virtuell maskin',
    haStateCol: 'Status',
    haRestartsCol: 'HA-omstarter',
    haLastEventCol: 'Siste hendelse',
    haToggleCol: 'HA',
    haCrashLoop: 'crash-loop',
    haToggleError: 'HA-endringen ble avvist',
    rules: {
      title: 'Affinitetsregler',
      createTitle: 'Ny nærhetsregel',
      editTitle: 'Rediger regel',
      nameHint: 'Små bokstaver, sifre og bindestreker (DNS-etikett)',
      vms: 'Virtuelle maskiner',
      vmsHint: 'Minst to VM-er — regelen binder hvor de kjører i forhold til hverandre',
      type: 'Type',
      affinity: 'Affinitet (sammen)',
      antiAffinity: 'Anti-affinitet (adskilt)',
      typeAffinityHint: 'VM-ene skal kjøre på SAMME node.',
      typeAntiAffinityHint: 'VM-ene skal kjøre på FORSKJELLIGE noder — det klassiske HA-paret.',
      mode: 'Modus',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Brudd avviser operasjonen (start, migrering, failover) med en talende feil.',
      modeSoftHint: 'Preferanse, aldri blokkerende: en placement i brudd fortsetter med en synlig advarsel.',
      satisfied: 'Placement',
      satisfiedYes: 'overholdt',
      satisfiedNo: 'brutt',
      violations: 'Brudd',
      noViolations: 'Ingen'
    },
    events: {
      title: 'HA-hendelser',
      subtitle: 'Tilgjengelighetsjournalen — omstarter, fencing, failover og de ærlige hoppene over',
      none: 'Ingenting ennå.',
      when: 'Når',
      kind: 'Hendelse',
      target: 'Objekt',
      detail: 'Detalj',
      kindRestarted: 'HA-omstart',
      kindGaveUp: 'ga opp (crash-loop)',
      kindNodeAttested: 'node fencet',
      kindFailedOver: 'failover',
      kindNoCandidate: 'ingen kandidat',
      kindStorageLocalSkip: 'hoppet over (lokal storage)',
      kindZombieFenced: 'zombie terminert'
    }
  }
}
